import { createAction, props } from '@ngrx/store';
import { actionName } from '../store-util';
import { QueryParams } from '../../services';

const STORE_NAME = 'AUTH_MODULE';

const initQueryParams = createAction(actionName(STORE_NAME, 'Init Query Params'));
const setQueryParams = createAction(actionName(STORE_NAME, 'Set Query Params'), props<{ queryParams: QueryParams }>());

const stopUpdate = createAction(actionName(STORE_NAME, 'Stop Update'));

export const AuthActions = {
  initQueryParams,
  setQueryParams,
  stopUpdate,
};
